import Axios from "axios";
import configData from "../config/config.json";

export default Axios.create({
  baseURL: configData.UrlApi + "api",
});
